<
<template>
	<div class="c-popup-block-options" v-if="target">
		<Popup :active="options.active" :target="target" @onClose="onClose">
			<div class="c-popup-block-options__inner">
				<a href="#" class="danger" @click.prevent="onDelete" v-if="showDelete">
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M5.93777 20.0665L6.93555 20L5.93777 20.0665ZM18.0622 20.0665L17.0644 20L18.0622 20.0665ZM3 5C2.44772 5 2 5.44772 2 6C2 6.55228 2.44772 7 3 7V5ZM21 7C21.5523 7 22 6.55228 22 6C22 5.44772 21.5523 5 21 5V7ZM11 11C11 10.4477 10.5523 10 10 10C9.44772 10 9 10.4477 9 11H11ZM9 16C9 16.5523 9.44772 17 10 17C10.5523 17 11 16.5523 11 16H9ZM15 11C15 10.4477 14.5523 10 14 10C13.4477 10 13 10.4477 13 11H15ZM13 16C13 16.5523 13.4477 17 14 17C14.5523 17 15 16.5523 15 16H13ZM14.9056 6.24926C15.0432 6.78411 15.5884 7.1061 16.1233 6.96844C16.6581 6.83078 16.9801 6.28559 16.8424 5.75074L14.9056 6.24926ZM4.00221 6.06652L4.93998 20.133L6.93555 20L5.99779 5.93348L4.00221 6.06652ZM6.93555 22H17.0644V20H6.93555V22ZM19.06 20.133L19.9978 6.06652L18.0022 5.93348L17.0644 20L19.06 20.133ZM19 5H5V7H19V5ZM3 7H5V5H3V7ZM19 7H21V5H19V7ZM17.0644 22C18.1174 22 18.99 21.1836 19.06 20.133L17.0644 20H17.0644V22ZM4.93998 20.133C5.01002 21.1836 5.88262 22 6.93555 22V20L4.93998 20.133ZM9 11V16H11V11H9ZM13 11V16H15V11H13ZM12 4C13.3965 4 14.5725 4.95512 14.9056 6.24926L16.8424 5.75074C16.2874 3.59442 14.3312 2 12 2V4ZM9.09447 6.24926C9.42756 4.95512 10.6035 4 12 4V2C9.66885 2 7.7126 3.59442 7.1576 5.75074L9.09447 6.24926Z"
							fill="currentColor"
						/>
					</svg>

					<span> Delete </span>
				</a>
				<a
					href="#"
					@click.prevent="onRemoveFromBoard"
					v-if="showRemoveFromBoard"
				>
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M2 15L5 13.95M22 8L19 9.05M5 13.95V4C5 3.44772 5.44772 3 6 3H18C18.5523 3 19 3.44772 19 4V9.05M5 13.95L19 9.05M5 19V20.0026C5 20.8129 5.9133 21.2868 6.57581 20.8202L11.4242 17.4055C11.7695 17.1623 12.2305 17.1623 12.5758 17.4055L17.4242 20.8202C18.0867 21.2868 19 20.8129 19 20.0026V14"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
						/>
					</svg>

					<span> Remove from board </span>
				</a>
				<a href="#" @click.prevent="onCopy">
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M2 3.5C2 2.67157 2.67157 2 3.5 2H14.5C15.3284 2 16 2.67157 16 3.5V8H20.5C21.3284 8 22 8.67157 22 9.5V20.5C22 21.3284 21.3284 22 20.5 22H9.5C8.67157 22 8 21.3284 8 20.5V16H3.5C2.67157 16 2 15.3284 2 14.5V3.5ZM14 8H9.5C8.67157 8 8 8.67157 8 9.5V14H4V4H14V8Z"
							fill="currentColor"
						/>
					</svg>

					<span> Copy Public Ad link </span>
				</a>

				<TagSelector :adId="adId" @onEdit="onEdit"></TagSelector>
			</div>
		</Popup>
	</div>
</template>

<script>
import Popup from './index';
import TagSelector from '@swipekit/components/utils/tag-selector';
import api from '@swipekit/lib/api';

export default {
	components: {
		Popup,
		TagSelector,
	},

	data: function () {
		return {
			options: {
				active: false,
			},
			tags: [
				{
					name: 'All Ads',
					slug: 0,
				},
				{
					name: 'Active',
					slug: 1,
				},
				{
					name: 'Inactive',
					slug: 2,
				},
			],
			selectedActiveAds: 0,
		};
	},

	props: {
		active: {
			type: Boolean,
			default: false,
		},
		target: {},
		adId: {},
		type: {
			type: String,
		},
		showRemoveFromBoard: {
			type: Boolean,
			default: false,
		},
		showDelete: {
			type: Boolean,
			default: false,
		},
	},

	watch: {
		active: function () {
			setTimeout(() => {
				if (this.active) {
					this.options.active = true;
					this.focusInput();
				} else {
					this.options.active = false;
				}
			}, 2);
		},
		selectedActiveAds: function () {
			this.$emit('input', this.selectedActiveAds);
		},
	},

	methods: {
		onEdit: function (res) {
			this.$emit('onEdit', res);
		},
		focusInput: function () {
			let input = this.$el.querySelector('input');
			if (input) {
				setTimeout(() => {
					input.focus();
				}, 100);
			}
		},
		onCopy: async function () {
			let adId = this.adId;

			if (typeof adId === 'object') {
				adId = adId.id;
			}

			await navigator.clipboard.writeText(`https://swipekit.app/block/${adId}`);
			api.api.track({
				name: 'ad_link_copied',
				adId,
			}).catch(() => {});

			this.$store.dispatch('message/onAdLinkCopy');
		},
		onDelete: function () {
			this.$emit('onDelete', this.adId);
		},
		onRemoveFromBoard: function () {
			this.$emit('onRemoveFromBoard', this.adId);
		},
		onClose: function () {
			if (!this.options.active) {
				return;
			}
			this.$emit('onClose');
		},
	},

	created: function () {},
};
</script>

<style lang="scss">
.c-popup-block-options {
	.c-popup {
		width: 280px;

		background: var(--color-bg-2);
		box-shadow: inset 0px 0px 0px 1px rgba(255, 255, 255, 0.4),
			inset 0 4px 6px 1px rgba(255, 255, 255, 0.2), var(--item-box-shadow);
		transition: all var(--transition-time) ease-out;

		&__arrow {
			color: var(--color-bg-2);
			top: -11px;
		}
	}
	article {
		//padding: var(--margin) var(--margin-lg);
	}

	&__inner {
		padding: var(--margin);

		a {
			width: 100%;
			display: flex;
			margin-bottom: var(--margin);
			padding: var(--margin);
			align-items: center;
			background-color: hsl(var(--color-bg-4), 0%, 94%);
			color: var(--color-font);
			font-weight: 450;
			font-size: var(--font-size-xs);
			user-select: none;
			border-radius: 5px;
			transition: all 120ms ease-out;
			text-decoration: none !important;

			svg {
				width: 20px;
				height: 20px;
				margin-right: var(--margin);
			}

			&:hover,
			&:active {
				background-color: var(--color-bg-5);
			}

			&.danger {
				background-color: hsl(var(--hue-danger), 80%, 94%);
				color: var(--color-danger);

				&:hover {
					background-color: var(--color-danger);
					color: var(--color-bg-1);
				}
			}

			&:last-child {
				margin-bottom: 0;
			}
		}
	}
}
</style>
